module.exports = __webpack_public_path__ + "img/D-WA-icon.d32a0be1.svg";